<script>
  import { _ as t } from "svelte-i18n";
  import { danger, info } from "notifications/notify.js";
  import { Button } from "t2c-components";

  export let onSave;
  export let onClose;
  export let title;
  export let name;
  export let description;
  export let action;

  let error;
  let detail;

  const handleSave = () => {
    if (name && name.length > 0) {
      action(name, description)
        .then((res) => {
          info($t("document.successUpdate"));
          onSave();
        })
        .catch((e) => {
          console.log(e);
          danger(`Error while deleting:\n${e.message}`);
          error = e;
        });
    } else {
      detail = $t("common.undefinedName");
    }
  };

  const handleClose = () => {
    onClose();
  };
</script>

<div class="modal">
  <h1>{title}</h1>
  <div class="form-item">
    <label for="name" style="margin-bottom: 8px;">{$t("document.name")}</label>
    <input
      id="name"
      bind:value={name}
      type="text"
      placeholder="Corporate Records"
    />
  </div>

  <div class="form-item">
    <label for="desc" style="margin-bottom: 8px;">
      {$t("document.description")}
    </label>
    <textarea id="desc" bind:value={description} type="text" />
  </div>
  {#if error}
    <p class="error">{error}</p>
    <ul class="error">
      {#each error.graphQLErrors as gqlError}
        <li>{$t(`common.${gqlError.key}`) || ""}: {gqlError.message}</li>
      {/each}
    </ul>
  {/if}
  {#if detail}
    <p class="error">{detail}</p>
  {/if}
  <div class="actions">
    <div style="margin-right: 1rem;">
      <Button on:click={handleClose}>{$t("common.back")}</Button>
    </div>
    <Button style="filled" on:click={handleSave}>{$t("common.save")}</Button>
  </div>
</div>

<style>
  .modal {
    margin: 2rem;
  }
  .modal h1 {
    font-size: 24px;
    text-transform: uppercase;
    font-family: "IBM Plex Sans";
    font-weight: 700;
    letter-spacing: 0.02rem;
    margin: 0;
  }

  .form-item {
    margin: 24px 0;
    min-width: 350px;
  }

  @media only screen and (max-width: 767px) {
    .form-item {
      min-width: auto;
    }
  }

  .form-item input {
    width: 100%;
    margin-top: 1rem;
    padding: 10px;
    border: 2px solid #eee;
    background-color: #eee;
    transition: border 0.3s ease-in-out;
  }

  .form-item input:focus {
    border: 2px solid black;
    background-color: #f6f6f6;
    outline: none;
  }

  .form-item textarea {
    width: 100%;
    margin-top: 1rem;
    padding: 10px;
    border: 2px solid #eee;
    background-color: #eee;
    transition: border 0.3s ease-in-out;
  }

  .form-item textarea:focus {
    border: 2px solid black;
    background-color: #f6f6f6;
    outline: none;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 1rem;
  }

  .error {
    color: red;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .error li {
    margin: 0;
    padding: 0;
  }
</style>
